module.exports = __webpack_public_path__ + "static/media/marker.c0c78df7.svg";